import { buildOrderBillEntriesFromCartEntries } from "@/utils/selfServicePrintBill";
import QrReader from "../QrReader.vue";
import LossReasonSelect from "../LossReasonSelect.vue";
import OrderList from "../OrderList.vue";
import CakeQuestion from "../CakeQuestion.vue";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { FindAvailableCampaigns } from "@/api/Campaign.js";
export default {
  data() {
    return {
      baskets: [],
      basketCount: 0,
      selected: "",
      moment: require('moment-timezone'),
      currentTime: "",
      broadcaster: null,
      isMobileButtonOpen: false,
      removeEntryPopupActive: false,
      removeEntryReason: "",
      customerInfoPopupActive: false,
      tempCustomer: null,
      campaignQr: "",
      displayCampaignQr: "",
      campaignQrTimeout: null,
      isAllSelected: false,
      /** Ödeme sonrası mobilde PS katmanı eski satırları tutabiliyor; boşalışta remount. */
      cartScrollRemountKey: 0,
      _prevSelfServiceCartLen: null
    };
  },
  components: {
    OrderList,
    CakeQuestion,
    LossReasonSelect,
    QrReader,
    VuePerfectScrollbar
  },
  mounted() {
    this.getCurrentTime();
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if (val.id && !this.lossMode) {
          //this.$store.dispatch("selfservice/setToUpdateEntry", null)
          this.$store.dispatch("selfservice/setSelectedProduct", null);
          this.$store.dispatch("selfservice/setPreSelectedProduct", null);
          this.$nextTick(() => {
            this.$store.dispatch("selfservice/setToUpdateEntry", val);
          });
        }
      }
    },
    toUpdateEntry(val) {
      if (!val) this.selected = "";
    },
    // Sepetteki değişiklikleri izle
    'currentCart.cartEntries': {
      deep: true,
      handler(newCartEntries) {
        const len = newCartEntries ? newCartEntries.length : 0;
        const prev = this._prevSelfServiceCartLen;
        if (!this.lossMode && prev != null && prev > 0 && len === 0) {
          this.cartScrollRemountKey += 1;
        }
        this._prevSelfServiceCartLen = len;
        if (len === 0) {
          this.isAllSelected = false;
        }

        console.log('handle', newCartEntries);
        if (newCartEntries) {
          // Değişiklikleri yayınla
          this.broadcaster.postMessage({
            type: 'CART_UPDATE',
            data: newCartEntries
          });
        }
        this.$nextTick(() => {
          const ps = this.$refs.cartOrderScrollbar;
          if (ps && typeof ps.update === 'function') {
            ps.update();
          }
        });
      }
    }
  },
  beforeDestroy() {
    // Kanalı temizle
    if (this.broadcaster) {
      this.broadcaster.postMessage({
        type: 'CART_UPDATE',
        data: []
      });
      this.broadcaster.close();
    }
  },
  created() {
    const c = this.currentCart;
    this._prevSelfServiceCartLen =
      c && c.cartEntries ? c.cartEntries.length : 0;
    this.broadcaster = new BroadcastChannel('cart-channel');
    console.log(this.currentCart.cartEntries);
    if (this.currentCart.cartEntries) {
      this.broadcaster.postMessage({
        type: 'CART_UPDATE',
        data: []
      });
    }

    //   this.broadcaster.onmessage = (event) => {
    //   if (event.data.type === 'CART_UPDATE') {
    //     console.log(event.data.data);
    //   }
    // };
  },
  computed: {
    isCakeQuestioned: {
      get() {
        return this.$store.getters["selfservice/getCakeQuestioned"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setCakeQuestioned", val);
      }
    },
    isOrderListActive() {
      return this.$refs.orderList ? this.$refs.orderList.isActive : false;
    },
    selectedLossStocks() {
      return this.$store.getters["selfservice/getSelectedLossStocks"]
    },
    isMobileButtonOpenGetter: {
      get() {
        return this.isMobileButtonOpen;
      },
      set(val) {
        this.isMobileButtonOpen = val;
      },
    },
    lossTypeSelection: {
      get() {
        return this.$store.getters["selfservice/getLossType"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossType", val);
      }
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      }
    },
    currentCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    carts: function () {
      return this.$store.getters["selfservice/getCarts"];
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      }
    },
    activePersonal: {
      get() {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal");
      }
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    currentDate() {
      let date = this.moment().locale("tr");
      date = date.tz("Europe/Istanbul").format("ddd Do MMM")
      return date;
    },
    /** Sepette totalPayedPrice başta yoktu; koşul yüzünden toplam hep 0 TL görünüyordu. */
    cartOrderDisplayTotal() {
      const c = this.currentCart;
      if (!c) return 0;
      const paid =
        c.totalPayedPrice != null && c.totalPayedPrice !== ""
          ? Number(c.totalPayedPrice)
          : 0;
      let total =
        c.totalPrice != null && c.totalPrice !== ""
          ? Number(c.totalPrice)
          : NaN;
      if (!Number.isFinite(total)) total = 0;
      if (
        total === 0 &&
        c.cartEntries &&
        c.cartEntries.length > 0
      ) {
        const sum = c.cartEntries.reduce(
          (s, e) => s + (Number(e && e.price) || 0),
          0
        );
        if (sum > 0) total = Math.round(sum * 100) / 100;
      }
      const due = total - (Number.isFinite(paid) ? paid : 0);
      return Math.round(due * 100) / 100;
    },
    /** "Seçilen müşteri : Ad S***" (soyad ilk harf + maske) */
    selectedCustomerMaskedLine() {
      const c = this.currentCart && this.currentCart.customer;
      if (!c) return "";
      const first = (c.name || "").trim();
      const maskedLast = this.maskCustomerSurname(c.surname || "");
      const namePart = first || (c.userName || c.UserName || "").trim() || "—";
      const lastPart = maskedLast ? ` ${maskedLast}` : "";
      return `Seçilen müşteri : ${namePart}${lastPart}`;
    },
  },
  methods: {
    /** Soyad: DB’deki ilk karakter aynen + *** (büyük harfe çevrilmez) */
    maskCustomerSurname(surname) {
      const s = String(surname || "").trim();
      if (!s.length) return "";
      return `${s.charAt(0)}***`;
    },
    clearQr() {
      this.$store.dispatch("selfservice/setCurrentCartCustomer", null);
    },
    commitQrCode(customer) {
      if (customer) {
        this.tempCustomer = customer;
        this.customerInfoPopupActive = true;
        this.campaignQr = "";
        this.displayCampaignQr = "";
        this.$nextTick(() => {
          if (this.$refs.campaignQrInput) {
            this.$refs.campaignQrInput.focus();
          }
        });
      }
    },
    onCustomerPopupClose(val) {
      if (!val) {
        this.customerInfoPopupActive = false;
        this.tempCustomer = null;
        this.campaignQr = "";
        this.displayCampaignQr = "";
      }
    },
    closeCustomerInfoPopup() {
      this.customerInfoPopupActive = false;
      this.tempCustomer = null;
      this.campaignQr = "";
      this.displayCampaignQr = "";
    },
    applyCustomerAndCampaign() {
      this.validateAndApplyCampaign();
    },
    focusCampaignQrInput() {
      if (this.$refs.campaignQrInput) {
        this.$refs.campaignQrInput.focus();
      }
    },
    validateAndApplyCampaign() {
      if (!this.tempCustomer) return;
      
      // If no campaign QR code is entered, apply customer directly and close
      if (!this.campaignQr) {
        this.tempCustomer.campaignQrCode = null;
        this.$store.dispatch("selfservice/setCurrentCartCustomer", this.tempCustomer);
        this.customerInfoPopupActive = false;
        this.tempCustomer = null;
        this.campaignQr = "";
        this.displayCampaignQr = "";
        this.$vs.notify({
          color: "success",
          title: "Başarılı",
          text: "Müşteri sepete başarıyla tanımlandı!"
        });
        return;
      }
      
      let cart = this.currentCart;
      if (!cart) return;
      
      const activePersonel = this.$store.getters["selfservice/getActivePersonal"];
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const cartEntries = (cart.cartEntries || []).map(x => {
        const entry = { ...x };
        if (entry.categories && entry.categories.length > 0) {
          entry.categoryId = entry.categories[0].id;
        }
        return entry;
      });

      let orderModel = {
        id: cart.id,
        customerId: this.tempCustomer.id,
        qrCode: cart.partnerQr ? cart.partnerQr.qrCode : this.tempCustomer.giftQrCode,
        campaignQrCode: this.campaignQr,
        partnerCampaignQrId: cart.partnerQr ? cart.partnerQr.partnerCampaignQrId : null,
        totalPrice: cart.totalPrice,
        active: cart.active,
        cartEntries: cartEntries,
        branchName: userInfo && userInfo.branch ? userInfo.branch.name : "",
        paymentInformations: [],
        userName: activePersonel ? activePersonel.name : "",
        userId: activePersonel ? Number(activePersonel.id) : 0,
      };
      
      this.$vs.loading({
        container: '.customer-info-campaign-popup',
        scale: 0.6
      });
      
      FindAvailableCampaigns(orderModel).then(res => {
        this.$vs.loading.close('.customer-info-campaign-popup > .con-vs-loading');
        if (res && res.status == 200 && res.data) {
          const isValid = res.data.isValid || res.data.IsValid;
          if (res.data.campaignTitle && isValid) {
            // Eşleşme var ve şartlar sağlandı! (Match exists and conditions are met!)
            this.$vs.notify({
              color: "success",
              title: "Kampanya Tanımlandı",
              text: `${res.data.campaignTitle} kampanyası başarıyla tanımlandı!`,
              position: "bottom-right",
              time: 5000
            });

            // Apply customer and campaign code
            this.tempCustomer.campaignQrCode = this.campaignQr;
            this.$store.dispatch("selfservice/setCurrentCartCustomer", this.tempCustomer);

            const newEntries = res.data.newEntries || res.data.NewEntries;
            if (newEntries && newEntries.length > 0) {
              this.$store.dispatch("selfservice/setCurrentCartWithCampaign", newEntries);
            }

            this.customerInfoPopupActive = false;
            this.tempCustomer = null;
            this.campaignQr = "";
            this.displayCampaignQr = "";
          } else if (res.data.campaignTitle) {
            // Kampanya bulundu ama sepet şartları karşılamıyor (ör. gereken adet/ürün eksik)
            this.$vs.notify({
              color: "warning",
              title: "Kampanya Şartları Sağlanmadı",
              text: `${res.data.campaignTitle} kampanyası bulundu ancak sepet bu kampanyanın şartlarını karşılamıyor.`,
              position: "bottom-right",
              time: 6000
            });
            this.campaignQr = "";
            this.displayCampaignQr = "";
          } else {
            // Eşleşme yok! (No match!)
            this.$vs.notify({
              color: "warning",
              title: "Geçersiz Kampanya Kodu",
              text: "Girdiğiniz QR koduna uygun aktif bir kampanya bulunamadı!",
              position: "bottom-right"
            });
            this.campaignQr = "";
            this.displayCampaignQr = "";
          }
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Kampanya doğrulanırken bir hata oluştu!"
          });
          this.campaignQr = "";
          this.displayCampaignQr = "";
        }
      }).catch(err => {
        this.$vs.loading.close('.customer-info-campaign-popup > .con-vs-loading');
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Sunucu bağlantı hatası!"
        });
        this.campaignQr = "";
        this.displayCampaignQr = "";
      });
    },
    handleCampaignQrInput(e) {
      const val = e.target.value;
      const diff = val.length - this.campaignQr.length;
      if (diff < 0) {
        this.campaignQr = this.campaignQr.substring(0, val.length);
      } else if (diff > 0) {
        const added = val.substring(val.length - diff);
        this.campaignQr += added;
      }
      
      if (this.campaignQr.length > 0) {
        const lastChar = this.campaignQr.charAt(this.campaignQr.length - 1);
        this.displayCampaignQr = "*".repeat(this.campaignQr.length - 1) + lastChar;
      } else {
        this.displayCampaignQr = "";
      }
      
      if (this.campaignQrTimeout) clearTimeout(this.campaignQrTimeout);
      this.campaignQrTimeout = setTimeout(() => {
        this.displayCampaignQr = "*".repeat(this.campaignQr.length);
      }, 400);

      if (this.campaignQr.length === 10) {
        this.validateAndApplyCampaign();
      }
    },
    openQrReader() {
      this.$refs.qrReader.isActive = true;
    },
    /** Zayiat API başarılı; sepet ve seçimleri sipariş sonrası ile aynı aksiyonla temizle, modu kapat. */
    async onLossReasonDone() {
      await this.$store.dispatch("selfservice/finalizeSuccessfulSelfServiceOrder");
      this.selected = "";
      this.lossMode = false;
    },
    submitLoss: function () {
      let obj = {
        stockEntries: this.selectedLossStocks,
        branchId: 0,
        userId: 0,
        type: "Stock"
      };
      this.$refs.lossReasonSelect.isActive = true;
      this.$refs.lossReasonSelect.lossData = obj;
    },
    clearLossList() {
      if (this.selected.id) this.$store.dispatch("selfservice/removeSelectedLossStock", this.selected.id);
      else this.$store.dispatch("selfservice/clearSelectedLossStocks");
      this.selected = "";
    },
    returnSelectedExtraVariant(extra) {
      let returnObj = [];
      let selectedVariants = extra.variants.filter(x => {
        if (x.quantity > 0) {
          returnObj.push("x" + x.quantity + " | " + x.name)
        }
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    moveOnToOrderList() {
      this.$refs.cakeQuestion.isActive = false;
      this.$refs.orderList.isActive = true;
    },
    getCurrentTime() {
      this.currentTime = this.moment().locale("tr");
      this.currentTime = this.currentTime.tz('Europe/Istanbul').format("H:mm:ss");
      setTimeout(this.getCurrentTime, 1000)
    },
    clickRow(tr) {
      if (this.isAllSelected) {
        this.isAllSelected = false;
      }
      this.selected = this.selected == tr ? "" : tr;
    },
    onSelectAllChange() {
      if (this.isAllSelected) {
        this.selected = "";
        this.$store.dispatch("selfservice/setToUpdateEntry", null);
      }
    },
    ClearCart: function () {
      if (!this.currentCart) return;

      const entries = this.currentCart.cartEntries || [];

      /* Satış modunda: içi boş ve numarası 0'dan büyük adisyonu tamamen kaldır (2. sepet vb.) */
      if (
        !this.lossMode &&
        entries.length === 0 &&
        this.currentCart.id > 0
      ) {
        this.selected = "";
        this.isAllSelected = false;
        this.$store.dispatch("selfservice/setToUpdateEntry", null);
        this.$store.dispatch("selfservice/removeCart", this.currentCart.id);
        this.isCakeQuestioned = false;
        this.$vs.notify({
          color: "success",
          title: "Adisyon kaldırıldı",
          text: "Boş adisyon silindi.",
        });
        return;
      }

      if (entries.length === 0) {
        return;
      }
      if (!this.isAllSelected && (!this.selected || !this.selected.id)) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Silmek için listeden bir ürün seçin veya tümünü seçin."
        });
        return;
      }
      this.removeEntryReason = "";
      this.removeEntryPopupActive = true;
    },
    cancelRemoveEntryPopup() {
      this.removeEntryPopupActive = false;
      this.removeEntryReason = "";
    },
    confirmRemoveEntryFromCart() {
      const reason = (this.removeEntryReason || "").trim();
      if (!reason) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Silme işlemi için açıklama zorunludur."
        });
        return;
      }
      if (this.isAllSelected) {
        const entries = [...(this.currentCart.cartEntries || [])];
        entries.forEach(entry => {
          this.$store.dispatch("selfservice/removeEntryFromCurrentCart", {
            entry,
            removeReason: reason
          });
        });
        this.isAllSelected = false;
      } else {
        const entry = this.selected;
        this.$store.dispatch("selfservice/removeEntryFromCurrentCart", {
          entry,
          removeReason: reason
        });
      }
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.removeEntryPopupActive = false;
      this.removeEntryReason = "";
      this.selected = "";
      if (this.currentCart.cartEntries.length === 0) {
        this.$store.dispatch("selfservice/removeCart", this.currentCart.id);
        this.isCakeQuestioned = false;
      }
    },
    PlaceOrder: function () {
      console.log(this.currentCart.cartEntries);
      const orderBillEntries = buildOrderBillEntriesFromCartEntries(
        this.currentCart.cartEntries || []
      );
      if (!this.lossMode) {
        this.$refs.orderList.orderBillEntries = orderBillEntries;
        // this.$store.dispatch("selfservice/removeEntryFromCurrentCart", null);
        let navigationQuestion = this.$store.getters["selfservice/getNavigationQuestion"] || {};
        const qCatId =
          navigationQuestion.categoryId != null
            ? navigationQuestion.categoryId
            : navigationQuestion.CategoryId;
        const qProdId =
          navigationQuestion.productId != null
            ? navigationQuestion.productId
            : navigationQuestion.ProductId;
        if ((qCatId != null || qProdId != null) && !this.isCakeQuestioned && !this.currentCart.cartEntries.some(entry => entry.categories && entry.categories.some(category => category.id == qCatId))) {
          this.$refs.cakeQuestion.isActive = true;
        } else {
          this.moveOnToOrderList();
        }
      } else {
        let obj = {
          entries: orderBillEntries,
          branchId: 0,
          userId: 0,
          type: "Product"
        };
        this.$refs.lossReasonSelect.isActive = true;
        this.$refs.lossReasonSelect.lossData = obj;
      }
    },
    openNewBasket() {
      let id = this.carts.length;
      let newCart = {
        id: id,
        cartEntries: [],
        totalPrice: 0,
        totalPayedPrice: 0,
        active: true
      };
      this.$store.dispatch("selfservice/createNewCart", newCart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null)
      this.$store.dispatch("selfservice/setCakeQuestioned", false)
    },
    chanceCurrentCart(cart) {
      this.$store.dispatch("selfservice/setCurrentCart", cart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null)
    }
  }
};
